import { createContext } from 'react';
import { UserLocalOptionsClientInterface } from 'src/common/UserLocalOptionsClient/UserLocalOptionsClientInterface';

export type RuntimeContextProps = {
    isMobile: boolean;
    collator: Intl.Collator | null;
    modalRoot: HTMLElement;
    isRevitPlugin: boolean;
    isRevit6WayFiltered: boolean;
    userOptionsClient: UserLocalOptionsClientInterface;
};

export const RuntimeContext = createContext<RuntimeContextProps>({
    isMobile: false,
    collator: null,
    modalRoot: document.createElement('div'),
    isRevitPlugin: false,
    isRevit6WayFiltered: false,
    userOptionsClient: {
        isListDisplayModeEnabled: () => false,
        toggleDisplayMode: () => Promise.resolve(false),
    },
});
